"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHORT_DATE_TIME = exports.SHORT_TIME = exports.SHORT_DATE = void 0;
/** Example output: 1/31/2016 */
exports.SHORT_DATE = 'M/D/YYYY';
/** Example output: 4:20 pm */
exports.SHORT_TIME = 'h:mm a';
/** Example output: 1/31/2016 4:20 pm */
exports.SHORT_DATE_TIME = 'M/D/YYYY h:mm a';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWF0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvZm9ybWF0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxnQ0FBZ0M7QUFDbkIsUUFBQSxVQUFVLEdBQUcsVUFBVSxDQUFDO0FBQ3JDLDhCQUE4QjtBQUNqQixRQUFBLFVBQVUsR0FBRyxRQUFRLENBQUM7QUFDbkMsd0NBQXdDO0FBQzNCLFFBQUEsZUFBZSxHQUFHLGlCQUFpQixDQUFDIn0=